<template>
  <div id="app">
    <ParamError v-if="showParamError" />
    <div v-else-if="showApiError" class="api-error-mask">
      <div class="api-error-container">
        <h2 class="api-error-title">请求失败</h2>
        <p class="api-error-message">{{ apiErrorMessage }}</p>
      </div>
    </div>
    <router-view v-else />
  </div>
</template>

<script>
const pollInterval = 10 * 60 * 1000
import ParamError from './components/ParamError.vue'
import { validateParams, getCompanyId, getCostCenterId, getScreenId, getDeviceId } from './utils/params.js'

export default {
  name: 'App',
  components: {
    ParamError
  },
  data() {
    return {
      showParamError: false,
      showApiError: false,
      apiErrorMessage: '',
      pollTimer: null,
      refreshTimer: null,
      lastPage: ''
    }
  },
  mounted() {
    document.body.style.opacity = '1'
    this.checkParams()
    window.addEventListener('popstate', this.checkParams)
    this.startPagePolling()
    this.startAutoRefresh()
  },
  beforeDestroy() {
    window.removeEventListener('popstate', this.checkParams)
    this.stopPagePolling()
    this.stopAutoRefresh()
  },
  methods: {
    checkParams() {
      const { isValid } = validateParams()
      this.showParamError = !isValid
      if (!isValid) {
        this.stopPagePolling()
      } else if (!this.pollTimer) {
        this.startPagePolling()
      }
    },

    startPagePolling() {
      if (this.showParamError) return
      this.stopPagePolling()
      this.pollPage()
      this.pollTimer = setInterval(() => {
        this.pollPage()
      }, pollInterval)
    },

    stopPagePolling() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer)
        this.pollTimer = null
      }
    },

    async pollPage() {
      try {
        const companyId = getCompanyId()
        const costCenterId = getCostCenterId()
        const screenId = getScreenId()
        const deviceId = getDeviceId()

        const response = await fetch(`/screen/heartbeat?company_id=${companyId}&cost_center_id=${costCenterId}&screen_id=${screenId}&device_id=${deviceId}`)

        if (response.status === 429) {
          const errorData = await response.json()
          // this.stopPagePolling()
          this.showApiError = true
          this.apiErrorMessage = errorData && errorData.error ? errorData.error : '请求过于频繁，请稍后再试'
          return
        }

        // if (!response.ok) return
        // this.showApiError = false
        // const data = await response.json()
        // const page = data.cur_page

        // if (!page || page === this.lastPage) return

        // this.lastPage = page

        // const url = new URL(page, window.location.origin)
        // const query = {}
        // url.searchParams.forEach((value, key) => {
        //   query[key] = value
        // })

        // if (this.$route.path !== url.pathname || JSON.stringify(this.$route.query) !== JSON.stringify(query)) {
        //   console.log('页面变化:', url.pathname, query)
        //   this.$router.push({
        //     path: url.pathname,
        //     query
        //   }).catch(() => {})
        // }
      } catch (error) {
        console.error('页面轮询失败:', error)
      }
    },

    startAutoRefresh() {
      this.refreshTimer = setInterval(() => {
        // 食安/自定义大屏由 DailyRecord 按后端配置的刷新间隔自行刷新，避免重复整页刷新
        if (this.$route && this.$route.path === '/daily-record') return
        window.location.reload()
      }, 10 * 60 * 1000)
    },

    stopAutoRefresh() {
      if (this.refreshTimer) {
        clearInterval(this.refreshTimer)
        this.refreshTimer = null
      }
    }
  }
}
</script>

<style>
#app {
  width: 100%;
  height: 100%;
}

.api-error-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.api-error-container {
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  border-radius: 20px;
  padding: 40px 60px;
  text-align: center;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.1);
  max-width: 600px;
}

.api-error-title {
  color: #e74c3c;
  font-size: 28px;
  margin-bottom: 15px;
  font-weight: 600;
}

.api-error-message {
  color: #aaa;
  font-size: 16px;
  line-height: 1.6;
  word-break: break-word;
}
</style>